<template>
  <div>
    <p class="title">{{ title }}</p>
    <div>
      <el-radio-group
        v-model="selectedMutable"
        @change="update()"
        style="display: flex; flex-flow: column; row-gap: 10px;"
      >
        <el-radio
          v-for="(element, index) in elements"
          :key="index"
          :label="element"
        >
          {{ element.name }}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FilterComponentRadio',
  props: {
    title: {
      type: String,
      default: ''
    },
    elements: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    selected (newValue) {
      this.selectedMutable = newValue
    }
  },
  data () {
    return {
      selectedMutable: []
    }
  },
  created () {
    this.selectedMutable = this.selected
  },
  methods: {
    update () {
      this.$emit('update:selected', this.selectedMutable)
    }
  }
}
</script>
